import * as go from 'gojs';
import { sidebarConfig } from '../config/config';

export const setupDiagramGrid = (diagram: go.Diagram) => {
  const $ = go.GraphObject.make;
  const { color, size } = sidebarConfig.diagramGrid;

  diagram.grid = $(
    go.Panel,
    go.Panel.Grid,
    {
      visible: false,
      gridCellSize: new go.Size(size, size),
    },
    $(go.Shape, 'LineH', { stroke: color }),
    $(go.Shape, 'LineV', { stroke: color }),
  );
};
